export default __webpack_public_path__ + "static/media/slick.a4e97f5a.eot";